import React from 'react'
import Box from '@mui/material/Box'

function UserNavLabel (props: { labelText: string }): JSX.Element {
  return <Box className='user-nav__label'>{props.labelText}</Box>
}

export default UserNavLabel
